import { CcfBox } from '@nice-ccf/ui-controls';
import styles from './ccf-consumer-card-details-tab.module.scss';
import CcfConsumerCardDetailsTabCustomGeneralRow from './ccf-consumer-card-details-tab-custom-general-row';
import CcfConsumerCardDetailsTabCustomOthersRow from './ccf-consumer-card-details-tab-custom-others-row';
import CcfConsumerCardDetailsTabCustomAddressRow from './ccf-consumer-card-details-tab-custom-address-row';
import { useEffect, useState } from 'react';
import { getAppSpaceRatio } from '../../../global.app.slice';
import { useSelector } from 'react-redux';

/* eslint-disable-next-line */
export interface CcfConsumerCardDetailsTabProps {}

/**
 * Renders the details tab for the CcfConsumerCard component.
 *@example
 * @param props - The props for the CcfConsumerCardDetailsTab component.
 * @returns The rendered details tab.
 */
export function CcfConsumerCardDetailsTab(
  props: CcfConsumerCardDetailsTabProps
) {
  const [detailsMinValue, setDetailsMinValue] = useState(false);
  const appSpaceRatio = useSelector(getAppSpaceRatio);

  useEffect(() => {
    if (appSpaceRatio && appSpaceRatio <= 40) {
      setDetailsMinValue(true);
    } else {
      setDetailsMinValue(false);
    }
  }, [appSpaceRatio]);
  return (
    <CcfBox
      display={'flex'}
      flexDirection={'column'}
      width={'inherit'}
      className={styles['container']}
      id="agent_appSpace_detailsTab_parentContainer"
    >
      <CcfConsumerCardDetailsTabCustomGeneralRow headerCaption="GENERAL" detailsMinValue={detailsMinValue}/>
      <CcfConsumerCardDetailsTabCustomAddressRow headerCaption="ADDRESS" detailsMinValue={detailsMinValue} />
      <CcfConsumerCardDetailsTabCustomOthersRow headerCaption="OTHERS" detailsMinValue={detailsMinValue}/>
    </CcfBox>
  );
}

export default CcfConsumerCardDetailsTab;
